import { TicketRepository } from '../repositories/TicketRepository'

export function ListTicketDateCase(ticketRepository: TicketRepository) {
  return async function ({ personaId }: { personaId: string }) {
    return await ticketRepository.listTicketDate({ personaId })
  }
}
